import { isPhoneLikeChampName, tryNormalizePhoneToE164 } from "@/lib/phoneFormat";

/** Message si le numéro saisi ne peut pas être composé (appels Telnyx). */
export function phoneNormalizationError(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return null;
  if (tryNormalizePhoneToE164(s)) return null;
  return "Numéro invalide pour les appels : utilisez 06 12 34 56 78 ou +33 6 12 34 56 78.";
}

/** Vérifie les champs téléphone d’une fiche produit avant publication. */
export function findInvalidPhoneInFiche(customFields, champs) {
  const cf = customFields && typeof customFields === "object" ? customFields : {};
  for (const c of champs || []) {
    if (!c?.nom || !isPhoneLikeChampName(c.nom)) continue;
    const v = cf[c.nom];
    if (v == null || String(v).trim() === "") continue;
    const err = phoneNormalizationError(v);
    if (err) return `« ${c.nom} » : ${err}`;
  }
  return null;
}

/**
 * Stocke les téléphones en E.164 (+33…) pour les appels, quelle que soit la saisie (0… ou +33).
 */
export function normalizePhoneFieldsInDossierPayload(payload) {
  if (!payload || typeof payload !== "object") return payload;
  const out = { ...payload };

  if (out.client_phone != null && String(out.client_phone).trim() !== "") {
    const n = tryNormalizePhoneToE164(out.client_phone);
    if (n) out.client_phone = n;
  }

  if (out.custom_fields && typeof out.custom_fields === "object" && !Array.isArray(out.custom_fields)) {
    const cf = { ...out.custom_fields };
    for (const [key, val] of Object.entries(cf)) {
      if (!isPhoneLikeChampName(key)) continue;
      const raw = String(val ?? "").trim();
      if (!raw) continue;
      const n = tryNormalizePhoneToE164(raw);
      if (n) cf[key] = n;
    }
    out.custom_fields = cf;
  }

  return out;
}
